import {
  create_customer_base_info,
  get_card_record_time_alert_detail_list,
  update_customer_base_info,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model2/mjstore/mjstore-tips-config';

import { reactive } from 'vue';

const None = null;

const search_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const update_model_config_options = {};

const titleList = {
  title: '撤单管理',
  addModalTitle: '新建撤单',
  updateTitle: '修改撤单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '客人姓名',
    width: 150,
    dataIndex: 'customer__name',
    checked: true,
  },
  {
    title: '客人编号',
    width: 150,
    dataIndex: 'customer__code',
    checked: true,
  },
  {
    title: '所属门店',
    width: 150,
    dataIndex: 'customer__shop__name',
    checked: true,
  },
  {
    title: '所属顾问',
    width: 150,
    dataIndex: 'customer__adviser__name',
    checked: true,
  },
  {
    title: '项目类别',
    width: 150,
    dataIndex: 'card__project_type__name',
    checked: true,
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '生美项目', value: '生美项目' },
      { text: '医美项目', value: '医美项目' },
      { text: '养发项目', value: '养发项目' },
      { text: '康养项目', value: '康养项目' },
    ],
  },
  {
    title: '卡名称',
    width: 150,
    dataIndex: 'card__name',
    checked: true,
  },
  {
    title: '到期日期',
    width: 110,
    dataIndex: 'end_date',
    checked: true,
    slots: { customRender: 'date' },
  },
  // {
  //   title: '操作',
  //   width: 200,
  //   dataIndex: 'action',
  //   checked: true,
  //   slots: { customRender: 'action' },
  //   fixed: 'right',
  // },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: get_card_record_time_alert_detail_list,
    addData: create_customer_base_info,
    updateData: update_customer_base_info,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
